import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { MainContainer, SliderImageContainer } from "./styled.components";
import BAHRIATOWNLOGO from "../../../../assets/icons/bahriaTownLogo.png";
import SIEMENSLOGO from "../../../../assets/icons/siemens.png";
import DHALAHOREOGO from "../../../../assets/icons/dhaLahoreLogo.png";
import TELENORLOGO from "../../../../assets/icons/telenor.png";
const RegistrationSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <MainContainer>
      <Slider {...settings}>
        <SliderImageContainer>
          <img src={BAHRIATOWNLOGO} />
          <img src={TELENORLOGO} />
          <img src={SIEMENSLOGO} />
          <img src={DHALAHOREOGO} />
          <img src={SIEMENSLOGO} />
          <img src={BAHRIATOWNLOGO} />
          <img src={TELENORLOGO} />
        </SliderImageContainer>

        <SliderImageContainer>
          <img src={BAHRIATOWNLOGO} />
          <img src={TELENORLOGO} />
          <img src={SIEMENSLOGO} />
          <img src={DHALAHOREOGO} />
          <img src={SIEMENSLOGO} />
          <img src={BAHRIATOWNLOGO} />
        </SliderImageContainer>
        <SliderImageContainer>
          <img src={BAHRIATOWNLOGO} />
          <img src={TELENORLOGO} />
          <img src={SIEMENSLOGO} />
          <img src={DHALAHOREOGO} />
          <img src={SIEMENSLOGO} />
          <img src={BAHRIATOWNLOGO} />
        </SliderImageContainer>
      </Slider>
    </MainContainer>
  );
};

export default RegistrationSlider;
